import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async getZones(store) {
    const { commit, state, rootState } = store;
    return await axios({
      url: `/v1/events/${
        rootState.events.event.id
      }/skills/${
        state.skill.id
      }/zones/list?include=equipments`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setZones', resp.data.data);
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async createZone(store, zone) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/zones`,
      method: 'POST',
      data: { ...zone },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getZones');
        return Promise.resolve(zone);
      })
      .catch(parseApiError);
  },
  async updateZone(store, zone) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/zones/${zone.id}`,
      method: 'PUT',
      data: { ...zone },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getZones');
        return Promise.resolve(zone);
      })
      .catch(parseApiError);
  },
  async deleteZone(store, zoneID) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/zones/${zoneID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getZones');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async publisZones(store) {
    const { dispatch, state, rootState } = store;
    return await axios({
      url: `/v1/events/${rootState.events.event.id}/skills/${state.skill.id}/equipments/publish`,
      method: 'POST',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getSkill');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;